import { useChatStore } from "@stores/chat.store";
import { useAnalytics } from "@hooks/analytics";

import { FILTER_EVENT_NAMES, FILTER_TABS } from "./utils/conversations-filter.constants";

import type {
	TConversationsFilterConfig,
	TConversationsFilterLogicResult,
	TFilterTab,
} from "./conversations-filter.types";

/** Gerencia seleção de filtro por tag (Spam, Blocked, etc.) com disparo de analytics. */
export const useConversationsFilterLogic = ({
	onFilterChange,
}: TConversationsFilterConfig): TConversationsFilterLogicResult => {
	const { trackClick } = useAnalytics();
	const selectedTags = useChatStore((s) => s.conversation.selectedTags);

	const handleOnClick = (tab: TFilterTab) => {
		const eventName = FILTER_EVENT_NAMES[tab.tag];
		if (eventName) {
			trackClick({
				eventName,
				pageName: '/webmotors/garagem/chat',
				pageType: 'chat',
				flowType: 'garagem',
				tier: 3,
				recurringEvent: true,
			});
		}

		const newFilters: string[] = selectedTags.includes(tab.tag) ? [] : [tab.tag];

		if (onFilterChange) {
			onFilterChange(newFilters);
		}
	};

	return { filterTabs: FILTER_TABS, handleOnClick, selectedTags };
};
